import React from "react";
import {
	Grid,
	CheckCircleOutline
} from "@gti-controls-v2/web-core";
import loginStyles from "../../common/styles/Login";

const SendRecoveryEmail = () => {
    const styles = loginStyles;

    return (  
        <Grid container alignItems="center" justifyContent="center" spacing={1} >
                <div style={styles.sendRecoveryContainer}>
                    <CheckCircleOutline style={{ color: "#108043", fontSize: 70 }} />
                </div>
                <Grid item xs={12} sx={styles.sendRecoveryContainer}>
                    <div style={styles.title}>
                        ¡Enlace enviado!
                    </div>
                    <div style={{ marginTop: 30, marginBottom: 30 }}>
                        Te hemos enviado un enlace para restablecer tu contraseña. Por favor, revisa tu correo electrónico y sigue las instrucciones.
                    </div>
                </Grid>
        </Grid>
    );
};

export default SendRecoveryEmail;